import type { ModuleRoute } from '../util'
import { mixinParams } from '../util'
import { THESIS_TYPE } from '@/views/teacher/thesis/v2/constant'

export const thesisManagerRouteMap = {
  30001: {
    path: 'manage',
    name: 'ThesisAdviseManage',
    component: () => import('@/views/teacher/thesis/v2/ThesisAdvisePage.vue'),
    props: {
      type: THESIS_TYPE.enums.Manage.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30001],
      moduleChildren: [],
    },
  },
  30002: {
    path: 'advise',
    name: 'ThesisAdviseMine',
    component: () => import('@/views/teacher/thesis/v2/ThesisAdvisePage.vue'),
    props: {
      type: THESIS_TYPE.enums.Advisor.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30002],
      moduleChildren: [],
    },
  },
  30003: {
    path: 'coach',
    name: 'ThesisCoachMine',
    component: () => import('@/views/teacher/thesis/v2/ThesisAdvisePage.vue'),
    props: {
      type: THESIS_TYPE.enums.Coach.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30003],
      moduleChildren: [],
    },
  },
  30004: {
    path: 'review',
    name: 'ThesisAdviseReview',
    component: () => import('@/views/teacher/thesis/v2/ThesisAdvisePage.vue'),
    props: {
      type: THESIS_TYPE.enums.Review.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30004],
      moduleChildren: [],
    },
  },
}
mixinParams({ ...thesisManagerRouteMap }, { moduleName: 'thesis' })

export default {
  path: '/:symbol([A-Za-z]+)/manager/:module(thesis)/',
  component: () => import('@/components/teacher/layout/ManagerPageLayout.vue'),
  children: Object.values(thesisManagerRouteMap as ModuleRoute),
}
